import { render, staticRenderFns } from "./UnterrichtDashboardCover.vue?vue&type=template&id=efd08e1a&scoped=true&"
import script from "./UnterrichtDashboardCover.vue?vue&type=script&lang=ts&"
export * from "./UnterrichtDashboardCover.vue?vue&type=script&lang=ts&"
import style0 from "./UnterrichtDashboardCover.vue?vue&type=style&index=0&id=efd08e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd08e1a",
  null
  
)

export default component.exports